import axios from 'axios';

import { JsonResponse } from 'core/models/response';
import {
	RemainingSharesResponse,
	SaveShareholderPayload,
	ShareholderFromNationalId,
	ShareholdersListResponse,
	TreasuryPercentage,
} from '../models/shareholder';

export const onGetTreasuryShares = async () => {
	try {
		const response = await axios.get<JsonResponse<TreasuryPercentage>>('dashboard/shareholders/get-treasury-percentage');
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onUpdateTreasuryShares = async (total_number_of_treasury_shares: number) => {
	try {
		const response = await axios.put<JsonResponse<TreasuryPercentage>>('dashboard/shareholders/update-treasury-shares', {
			total_number_of_treasury_shares,
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onCheckNationalId = async (national_id: string) => {
	try {
		const response = await axios.get<JsonResponse<ShareholderFromNationalId>>('dashboard/shareholders/check-shareholder', {
			params: { national_id },
		});
		return response.data;
	} catch (error) {
		throw error;
	}
};

export const onSaveShareholder = async (shareholderPayload: SaveShareholderPayload) => {
	try {
		const response = await axios.post<JsonResponse<ShareholderFromNationalId>>('dashboard/shareholder', shareholderPayload);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onUpdateShareholder = async (id: number, shareholderPayload: SaveShareholderPayload) => {
	try {
		const response = await axios.put<JsonResponse<ShareholderFromNationalId>>(`dashboard/shareholder/${id}`, shareholderPayload);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetShareholders = async (page: number = 1) => {
	try {
		const response = await axios.get<JsonResponse<ShareholdersListResponse>>('dashboard/shareholder', { params: { page } });
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onSendForReview = async () => {
	try {
		const response = await axios.put('dashboard/shareholders/send-for-review', { terms_and_conditions: true });
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onDeleteShareholder = async (shareholderId: number) => {
	try {
		await axios.delete(`dashboard/shareholder/${shareholderId}`);
		return;
	} catch (error) {
		throw error;
	}
};

export const onGetRemainingShares = async () => {
	try {
		const response = await axios.get<JsonResponse<RemainingSharesResponse>>(`dashboard/shareholders/get-remaining-shares`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onDownloadTemplate = async () => {
	try {
		const response = await axios.get<JsonResponse<{ download_url: string }>>(`dashboard/shareholders/import-template`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onUploadTemplate = async (payload: FormData) => {
	try {
		const response = await axios.post(`dashboard/shareholders/import`, payload, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
